/**
 * router Actions
 */
import {
    QUERY_STRING_UPDATE,
    QUERY_STRING_DELETE,
    PUSH_WITH_STORED_SEARCH,
    QUERY_STRING_RESET
} from './constants';

import {
    UpdateQueryStringAction,
    DeleteQueryStringAction,
    ResetQueryStringAction,
    PushWithStoredSearchAction
} from './types';

export function updateQueryString(
    parameters: Record<string, any>
): UpdateQueryStringAction {
    return {
        type: QUERY_STRING_UPDATE,
        payload: parameters
    };
}

export function deleteQueryString(): DeleteQueryStringAction {
    return {
        type: QUERY_STRING_DELETE
    };
}

export function resetQueryString(): ResetQueryStringAction {
    return {
        type: QUERY_STRING_RESET
    };
}

export function pushWithStoredSearch(
    pathname: string
): PushWithStoredSearchAction {
    return {
        type: PUSH_WITH_STORED_SEARCH,
        payload: pathname
    };
}
